import { createAction, createReducer } from '@reduxjs/toolkit'

interface ReduxHomepage {
   typingAnimationStarted: boolean
   typingAnimationFinished: boolean
   spacingAnimationStarted: boolean
   spacingAnimationFinished: boolean
   transliterationAnimationStarted: boolean
   transliterationAnimationFinished: boolean
   toneMarkersAnimationStarted: boolean
   toneMarkersAnimationFinished: boolean
   meaningsAnimationStarted: boolean
   meaningsAnimationFinished: boolean
   phoneSearchTypingAnimationStarted: boolean
   phoneSearchTypingAnimationFinished: boolean
}

const homepageInitialState: ReduxHomepage = {
   typingAnimationStarted: false,
   typingAnimationFinished: false,
   spacingAnimationStarted: false,
   spacingAnimationFinished: false,
   transliterationAnimationStarted: false,
   transliterationAnimationFinished: false,
   toneMarkersAnimationStarted: false,
   toneMarkersAnimationFinished: false,
   meaningsAnimationStarted: false,
   meaningsAnimationFinished: false,
   phoneSearchTypingAnimationStarted: false,
   phoneSearchTypingAnimationFinished: false,
}

const typingAnimationStart = createAction('START_TYPING_ANIMATION')
const typingAnimationFinish = createAction('FINISH_TYPING_ANIMATION')
const spacingAnimationStart = createAction('START_SPACING_ANIMATION')
const spacingAnimationFinish = createAction('FINISH_SPACING_ANIMATION')
const transliterationAnimationStart = createAction('START_TRANSLITERATION_ANIMATION')
const transliterationAnimationFinish = createAction('FINISH_TRANSLITERATION_ANIMATION')
const toneMarkersAnimationStart = createAction('START_TONEMARKS_ANIMATION')
const toneMarkersAnimationFinish = createAction('FINISH_TONEMARKS_ANIMATION')
const meaningsAnimationStart = createAction('START_MEANINGS_ANIMATION')
const meaningsAnimationFinish = createAction('FINISH_MEANINGS_ANIMATION')
const phoneSearchTypingAnimationStart = createAction('START_PHONE_SEARCH_TYPING_ANIMATION')
const phoneSearchTypingAnimationFinish = createAction('FINISH_PHONE_SEARCH_TYPING_ANIMATION')

const homepageReducer = createReducer(homepageInitialState, (builder) => {
   builder.addCase(typingAnimationStart, (draft) => {
      draft.typingAnimationStarted = true
   })
   builder.addCase(typingAnimationFinish, (draft) => {
      draft.typingAnimationFinished = true
   })
   builder.addCase(spacingAnimationStart, (draft) => {
      draft.spacingAnimationStarted = true
   })
   builder.addCase(spacingAnimationFinish, (draft) => {
      draft.spacingAnimationFinished = true
   })
   builder.addCase(transliterationAnimationStart, (draft) => {
      draft.transliterationAnimationStarted = true
   })
   builder.addCase(transliterationAnimationFinish, (draft) => {
      draft.transliterationAnimationFinished = true
   })
   builder.addCase(toneMarkersAnimationStart, (draft) => {
      draft.toneMarkersAnimationStarted = true
   })
   builder.addCase(toneMarkersAnimationFinish, (draft) => {
      draft.toneMarkersAnimationFinished = true
   })
   builder.addCase(meaningsAnimationStart, (draft) => {
      draft.meaningsAnimationStarted = true
   })
   builder.addCase(meaningsAnimationFinish, (draft) => {
      draft.meaningsAnimationFinished = true
   })
   builder.addCase(phoneSearchTypingAnimationStart, (draft) => {
      draft.phoneSearchTypingAnimationStarted = true
   })
   builder.addCase(phoneSearchTypingAnimationFinish, (draft) => {
      draft.phoneSearchTypingAnimationFinished = true
   })

   return builder
})

export default homepageReducer
